import styled from 'foundations-theming-specialty/utils';
import { SEARCH_IFRAME_OFFSET_BOTTOM, SEARCH_IFRAME_OFFSET_TOP } from '../../constants';
export const StyledSearchScrollableWrapper = styled.div.withConfig({
  displayName: "StyledSearchScrollableWrapper",
  componentId: "zpwcen-0"
})(["--search-icon-fill:", ";display:block !important;", ""], ({
  isOpen,
  theme
}) => isOpen ? theme.color['icon-core-subtle'] : theme.color['global-shell-icon-nav-item-default'], ({
  isOpen,
  disableScroll,
  theme
}) => isOpen && `
        height: min-content !important;
        min-width: min(calc(515px + ${theme.space['600']} + ${theme.space['600']}), calc(100vw - var(--global-nav-vertical-nav-width) - 10px));
        overflow: ${disableScroll ? 'hidden' : 'auto'};
        position: relative;
        max-width: calc(100vw - var(--global-nav-vertical-nav-width) - 10px);
        max-height: calc(100vh - ${SEARCH_IFRAME_OFFSET_TOP}px - ${SEARCH_IFRAME_OFFSET_BOTTOM}px);
      `);